export default __webpack_public_path__ + "static/media/password.a5f87fb6.jpg";